export default __webpack_public_path__ + "static/media/14.5f7d8d9c.png";